export const PRODUCT_CATEGORY = {
    VSTS: 1,
    VSTT: 2,
}

export const SubscriptionType = {
    None: 0,
    Subscription: 1,
    Setup: 2,
    Recurring: 3
}

export const RecurringType = {
    None: 0,
    Monthly: 1,
    Annual: 2
}

export const SubscriptionStatus = {
    Pending: 0,
    Active: 1,
    Cancelled: 2,
    Deactivated: 3,
    Expired: 4,
}

export const SUBSCRIPTION_STATUS_BADGE_TYPES = [
    "warning", // Pending
    "stable", // Active
    "critical", // Cancelled
];